import React from 'react'
import PropTypes from 'prop-types'
import {
    AspectRatio,
    Box,
    Button,
    Flex,
    Img,
    ListItem,
    OrderedList,
    Text,
    useStyleConfig,
} from '@chakra-ui/react'
import {remCalc} from '../../../theme/_utils'
import useDamImage from '../../../custom-hooks/use-dam-image'
import {useGetCategoriesData} from '../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink, safeBuildUrl} from '../../../utils/contentstack-utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {Link} from 'react-router-dom'

export const Steps = ({
    heading = '',
    image = {},
    stepsGroup = [],
    button,
    maxWidth = remCalc(1280),
}) => {
    const styles = useStyleConfig('Steps')
    const damImage = useDamImage(image)

    const {buildUrl} = useMultiSite()
    const categoryData = useGetCategoriesData()
    const {url, label, isAbsolute} = getGlobalLink(button, categoryData)
    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: safeBuildUrl(url, buildUrl),
          }

    return (
        <Flex __css={{...styles.container}} data-testid="steps" maxW={maxWidth} direction="column">
            {heading && (
                <Text as="h2" textStyle="head-large" fontWeight={'medium'} {...styles.heading}>
                    {heading}
                </Text>
            )}
            <Flex direction={{base: 'column', md: `row${damImage.url && '-reverse'}`}}>
                {damImage.url && (
                    <Box px={remCalc(24)}>
                        <AspectRatio
                            ratio={damImage.ratio}
                            width={{base: '100%', lg: remCalc(450), md: remCalc(393), sm: '100%'}}
                        >
                            <Img src={damImage.url} alt={image?.alt || ''} pb={remCalc(24)} />
                        </AspectRatio>
                    </Box>
                )}
                <Flex direction="column" alignItems={{base: 'center', md: 'flex-start'}}>
                    {stepsGroup?.length > 0 && (
                        <OrderedList {...styles.list}>
                            {stepsGroup.map((step, sIndex) => (
                                <ListItem key={`step-${sIndex}`} {...styles.listli}>
                                    <Text
                                        textStyle="body-large"
                                        fontWeight={'normal'}
                                        {...styles.listnum}
                                    >
                                        {sIndex + 1}
                                    </Text>
                                    <Box>
                                        <Text textStyle="head-small" fontWeight={'medium'}>
                                            {step.title}
                                        </Text>
                                        <Text
                                            textStyle="body-large"
                                            fontWeight={'normal'}
                                            dangerouslySetInnerHTML={{__html: step.body_copy}}
                                        />
                                    </Box>
                                </ListItem>
                            ))}
                        </OrderedList>
                    )}
                    {label && url && (
                        <Button {...buttonProps} {...styles.cta} variant={'primary'}>
                            {label}
                        </Button>
                    )}
                </Flex>
            </Flex>
        </Flex>
    )
}

Steps.propTypes = {
    heading: PropTypes.string,
    image: PropTypes.shape(),
    stepsGroup: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            body_copy: PropTypes.string,
        }),
    ),
    button: PropTypes.shape(),
    maxWidth: PropTypes.string,
}
